import { withAxiosClient } from "./client";

function convertDateObjects(...args) {
    const dataIndex = 1;
    if (args?.[dataIndex]) {
        Object.entries(args[dataIndex]).forEach(([key, value]) => {
            if (value instanceof Date) {
                const parts = [
                    value.getFullYear(),
                    value.getMonth() + 1,
                    value.getDate(),
                ];

                args[dataIndex][key] = parts
                    .map((part) => part.toString().padStart(2, "0"))
                    .join("-");
            }
        });
    }

    return args;
}

/**
 * @typedef {import('axios').AxiosRequestConfig} AxiosConfig
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 * @typedef {Promise<AxiosResponse>} AxiosAsyncResponse
 *
 * @typedef {(url: string, configs: AxiosConfig) => AxiosAsyncResponse} WithoutBody
 * @typedef {(url: string, data:object, configs: AxiosConfig) => AxiosAsyncResponse} WithBody
 */

/**
 * @type {WithoutBody}
 */
export const requestGet = withAxiosClient((http, ...args) => http.get(...args));

/**
 * @type {WithBody}
 */
export const requestPut = withAxiosClient((http, ...args) =>
    http.put(...convertDateObjects(...args))
);

/**
 * @type {WithBody}
 */
export const requestPatch = withAxiosClient((http, ...args) =>
    http.patch(...convertDateObjects(...args))
);

/**
 * @type {WithBody}
 */
export const requestPost = withAxiosClient((http, ...args) =>
    http.post(...convertDateObjects(...args))
);

/**
 * @type {WithoutBody}
 */
export const requestDelete = withAxiosClient((http, ...args) =>
    http.delete(...args)
);
